var map = {
	"./pr-1.png": "e9ea",
	"./pr-2.png": "6f38",
	"./pr-3.png": "f81d",
	"./pr-4.png": "e0ea",
	"./pr-5.png": "1f1a",
	"./pr-6.png": "da35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "00c5";